export interface checkboxPropsInterface {
    id: string
    name: string
    disabled?: boolean | undefined
    checked?: boolean
    onChange?: React.ChangeEventHandler<HTMLInputElement>
}

export default function Checkbox(props: checkboxPropsInterface) {
    return (
        <div style={{width:"40px"}} className="form-check form-switch">
            <input
                id={ props.id }
                className="form-check-input"
                type="checkbox"
                disabled={ props.disabled }
                name={ props.name }
                /* defaultChecked={ props.checked } */
                checked={ props.checked }
                onChange={ props.onChange } />
        </div>
    )
}